export const reviews = [
        {
          "img": "https://lh3.googleusercontent.com/a-/ALV-UjW-ri5QLXyf6265vvlkLZHqGgsnVKNy_u6F3YwRmkc1xSrmnuk=s64-c-rp-mo-br100",
          "name": "Luigi Di Mare",
          "date": "",
          "rating": 5,
          "text": "Výborné jednání přátelský přístup a top sestřihy. Chci pochválit Jirku děkuji za střih více takových lidí jako jste Vy!"
        },
        {
          "img": "https://lh3.googleusercontent.com/a-/ALV-UjVOEKtn9z1_C44n7nzPG8RM0oIbgd8up5ABaWN-0gJ5HsVrCPU=s64-c-rp-mo-br100",
          "name": "Jan Havlíček",
          "date": "",
          "rating": 5,
          "text": "Pokud chcete vypadat skvěle a být spokojený tak doporučuji navštívit nikde jinde se nebudete cítit lépe jak tady."
        },
        {
          "img": "https://lh3.googleusercontent.com/a/ACg8ocKp18LuZAUMV-vgRxP5h0u0ecHBPx9QruSfrd3jSFZgDDvUzx8=s64-c-rp-mo-br100",
          "name": "Petr Volšička",
          "date": "",
          "rating": 5,
          "text": "Nadstandartní péče. Naprostá spokojenost. Holiče Jirku mohu pouze jen doporučit. Ještě jednou díky.🫡"
        },
        {
          "img": "https://lh3.googleusercontent.com/a/ACg8ocLyOOhFYWX9uVI0ybJZpwMh6P6uu258W0FlJV5Hb3JgYuHlFA=s64-c-rp-mo-br100",
          "name": "Jan Kadleček",
          "date": "",
          "rating": 5,
          "text": "Byl jsem velmi spokojen stříhala mě kačka, no můžu jen doporučit, příště přijdu jen sem 👍😊"
        },
        {
          "img": "https://lh3.googleusercontent.com/a-/ALV-UjWNJhVBLmY8vPduZbtnnANabBDfa90gBtkv_ItBGU9JJv22F3Sjtg=s64-c-rp-mo-ba2-br100",
          "name": "Mateusz Tyč",
          "date": "",
          "rating": 5,
          "text": "Profesionální a přátelský přístup, super atmosféra, nádherné výsledky. Není jiná možnost než 5z5"
        },
        {
          "img": "https://lh3.googleusercontent.com/a-/ALV-UjUdLql_WujSpoMv63EwjhLQkMUv2diurxLOdi89fRqbRV6OKnXa=s64-c-rp-mo-br100",
          "name": "PAWLIE POIZN",
          "date": "",
          "rating": 5,
          "text": "Nejlepší barbershop v Praze, profesionální přístup, přátelské prostředí. Maximální spokojenost, doporučuju."
        },
        {
          "img": "https://lh3.googleusercontent.com/a/ACg8ocLzfgTCuHdKW2atnum694w5r6QVdUQO7tTaPxdnanPvXvL9rw=s64-c-rp-mo-br100",
          "name": "Karel Uhlíř",
          "date": "",
          "rating": 5,
          "text": "Po několika změnách různých barber shopu jsem našel ten pravý. Jednoduše bomba od začátku až po konec. Barber Jirka je fakt borec co ví co dělá a nebojí se poradit jak s účesem, střihem nebo i výběrem kolínské. Jednoznačně doporučuji"
        },
        {
          "img": "https://lh3.googleusercontent.com/a/ACg8ocJxYoa02_ZtRJssVPv9qBOmru6E4LH8KxkKTQFWIkQoE7fb1w=s64-c-rp-mo-br100",
          "name": "Nikita Fesyukov",
          "date": "",
          "rating": 5,
          "text": "Chodím pravidelně a výsledek vždy perfektní. Obsluha parádní, přátelská - obzvlášť Jirka :) Mohu jen doporučit!"
        },
        {
          "img": "https://lh3.googleusercontent.com/a-/ALV-UjU13vg3r6kLwGefP8iQMWC_KSZDXEGsXHBrazhsReU5d3H4KsXu=s64-c-rp-mo-br100",
          "name": "Jan Malík",
          "date": "",
          "rating": 5,
          "text": "Vždy se sem rád vracím. Příjemné a přátelské prostředí, zkušení pracovníci kteří nejen vědí co dělají, ale taky dokáží člověku poradit tak, že si po opuštění salonu přijde jako vyměněný. Jednoznačně doporučuji!"
        }
    ]